<template>
    <template-generator-preview :layout="value.Content">
        <table class="table table-sm table-bordered mb-0">
            <thead>
                <tr>
                    <th colspan="3" class="text-center bg-light-primary">Başlangıç</th>
                    <th colspan="3" class="text-center bg-light-success">Bitiş</th>
                    <th colspan="3" class="text-center bg-light-info">Tutar</th>
                </tr>
                <tr>
                    <th>İl</th>
                    <th>İlçe</th>
                    <th>Mahalle</th>
                    <th>İl</th>
                    <th>İlçe</th>
                    <th>Mahalle</th>
                    <th>Tır/Treyler (TL)</th>
                    <th>Kırkayak (TL)</th>
                    <th>Kamyon (TL)</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(price,index) in value.AgreementInformationRoutePrices" :key="index">
                    <td>{{price.StartProvinceName || '-'}}</td>
                    <td>{{price.StartDistrictName || '-'}}</td>
                    <td>{{price.StartNeighbourhoodName || '-'}}</td>
                    <td>{{price.EndProvinceName || '-'}}</td>
                    <td>{{price.EndDistrictName || '-'}}</td>
                    <td>{{price.EndNeighbourhoodName || '-'}}</td>
                    <td>{{price.TreylerRoutePriceStr || '-'}}</td>
                    <td>{{price.KirkayakRoutePriceStr || '-'}}</td>
                    <td>{{price.KamyonRoutePriceStr || '-'}}</td>
                </tr>
            </tbody>
        </table>
    </template-generator-preview>
</template>

<script>
import TemplateGeneratorPreview from '@/views/template-generator/components/TemplateGeneratorPreview.vue'
export default {
    components:{
        TemplateGeneratorPreview
    },
    props:{
        value:Object
    }
}
</script>

<style>

</style>